import React from "react";

const TermsOfUse = () => (
  <div className="container py-5">
    <h1 className="mb-4">Terms of Use</h1>
    <p>
      By accessing or using this site, you agree to abide by the following terms and conditions. If you do not agree, please do not use this site.
    </p>
    <ul>
      <li><strong>Use of Content:</strong> All content is for personal, non-commercial use unless otherwise stated.</li>
      <li><strong>User Conduct:</strong> Do not misuse, disrupt, or attempt to harm the site or its users.</li>
      <li><strong>Intellectual Property:</strong> All trademarks, logos, and content are property of their respective owners.</li>
      <li><strong>Disclaimer:</strong> This site is provided “as is” without warranties of any kind. We are not liable for any damages arising from use of the site.</li>
      <li><strong>Changes:</strong> We may update these terms at any time. Continued use means you accept the new terms.</li>
    </ul>
    <p>
      For questions, please <a href="/contact">contact us</a>.
    </p>
  </div>
);

export default TermsOfUse;